import {Text} from '@/components/ui/text/Text'
import {StyledDashboardSectionContainer} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

interface DashboardSectionProps {
    title: string
    children: React.ReactNode
    endSlot?: React.ReactNode
}

export const DashboardSection = ({title, children, endSlot}: DashboardSectionProps) => {
    return (
        <StyledDashboardSectionContainer>
            <Flexbox justify="space-between" align="center">
                <Text palette="neutral" shade="900" size="textXl" weight={500}>
                    {title}
                </Text>
                {endSlot}
            </Flexbox>
            {children}
        </StyledDashboardSectionContainer>
    )
}
